module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "example_mov"
  }, [_c('div', {
    staticClass: "ex_text"
  }, [_c('v-icon', [_vm._v("local_movies")]), _vm._v("PC/모바일 인터플레이 실행 영상")], 1), _vm._v(" "), _c('div', {
    staticClass: "mov_select_box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.viewSample),
      expression: "viewSample"
    }],
    attrs: {
      "type": "radio",
      "name": "inter_mov",
      "value": "pc"
    },
    domProps: {
      "checked": _vm._q(_vm.viewSample, "pc")
    },
    on: {
      "change": [function($event) {
        _vm.viewSample = "pc"
      }, _vm.changeMov]
    }
  }), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.clickRadio('pc')
      }
    }
  }, [_vm._v("PC 인터플레이")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.viewSample),
      expression: "viewSample"
    }],
    attrs: {
      "type": "radio",
      "name": "inter_mov",
      "value": "mobile"
    },
    domProps: {
      "checked": _vm._q(_vm.viewSample, "mobile")
    },
    on: {
      "change": [function($event) {
        _vm.viewSample = "mobile"
      }, _vm.changeMov]
    }
  }), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.clickRadio('mobile')
      }
    }
  }, [_vm._v("모바일 인터플레이")])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('video', {
    staticClass: "video",
    attrs: {
      "id": "video_ip",
      "controls": ""
    }
  }, [_c('source', {
    attrs: {
      "src": "//cdn.interworksmedia.co.kr/sample/interplay_mobile.mp4",
      "type": "video/mp4"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f247a3c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mainScreen/SampleVideo.vue
// module id = 844
// module chunks = 1